export default "__VITE_ASSET__bce895a6__"